module.exports = __webpack_public_path__ + "img/bemajor.a33ab47f.jpg";